<div class="fac__header">
  <admin-breadcrumbs></admin-breadcrumbs>

  <h3>Facilities Import</h3>

</div>

<div class="ai-decision-logic">
  <div class="feature-toggle">
    <div class="feature-toggle-row">
      <span class="feature-toggle-title">AI Decision Logic</span>
      <button
        type="button"
        role="switch"
        class="switch"
        [class.is-on]="aiDecisionLogicEnabled"
        [attr.aria-checked]="aiDecisionLogicEnabled"
        [disabled]="aiDecisionLogicSaving"
        aria-label="Toggle AI Decision Logic"
        (click)="toggleAiDecisionLogic()"
      >
        <span class="switch-knob"></span>
      </button>
      <span class="feature-toggle-state" [class.is-on]="aiDecisionLogicEnabled">
        {{ aiDecisionLogicEnabled ? 'Enabled' : 'Disabled' }}
      </span>
    </div>
    <p class="feature-toggle-subtext">
      Enable AI decision logic to power the AI Admission Outlook in the referral screen.
    </p>
    <p *ngIf="saveMessage" class="save-message" role="alert">{{ saveMessage }}</p>
  </div>

  <div class="sub-tabs">
    <button
      *ngFor="let tab of subTabs"
      type="button"
      class="sub-tab-btn"
      [class.active]="currentSubTab === tab.key"
      (click)="selectSubTab(tab.key)"
    >
      {{ tab.label }}
    </button>
  </div>

  <div class="view-header">
    <h2 class="view-title">{{ currentCategory.title }}</h2>
    <p class="view-desc">{{ currentCategory.desc }}</p>
  </div>

  <p *ngIf="loadError" class="error-msg">{{ loadError }}</p>

  <div *ngIf="loading" class="loading-msg">Loading rules…</div>

  <div class="table-scroll-area" *ngIf="!loading">
    <div class="table-container">
      <table class="logic-table">
        <thead>
          <tr>
            <th class="sticky-col">Requirement / Condition</th>
            <th class="apply-all-col">Apply to All</th>
            <th *ngFor="let facility of facilities">{{ facility.displayName }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let rule of currentCategory?.rules; let rIdx = index; trackBy: trackByFacilityIndex">
            <td class="sticky-col requirement-cell">
              <strong>{{ rule.name }}</strong>
            </td>
            <td>
              <select
                class="apply-all-select"
                [value]="rule.masterState"
                (change)="setSegmentAll(rIdx, $any($event.target).value)"
              >
                <option value="decline">Decline</option>
                <option value="review">Review</option>
                <option value="na">N/A</option>
              </select>
            </td>
              <td *ngFor="let state of rule.states; let fIdx = index; trackBy: trackByFacilityIndex">              <select
                class="apply-all-select"
                [value]="state"
                (change)="setSegment(rIdx, fIdx, $any($event.target).value)"
              >
                <option value="decline">Decline</option>
                <option value="review">Review</option>
                <option value="na">N/A</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
